import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async index() {
    return useAsyncData('invoices', () => this.call('/spa/billing/invoices'))
  }

  async show(id: string) {
    return useAsyncData('invoices-show', () => this.call(`/spa/billing/invoices/${id}`))
  }

  async send(id: string): Promise<void> {
    return await this.call(`/spa/billing/invoices/${id}/send`, {
      method: 'post',
    })
  }
}
